import React from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { CheckOutlined } from '@ant-design/icons';
import { ChatMessageReadIcon } from './ChatMessageReadIcon';

export interface ChatMessageData {
  id: string;
  body: string;
  subject?: string;
  created_at: string;
  is_read: boolean;
  read_at?: string | null;
  is_sent: boolean;
  sender_farm_id: number;
  recipient_farm_id: number;
  sender_user_name?: string | null;
  sender_farm?: {
    id: number;
    name: string;
    brand?: string;
  } | null;
  recipient_farm?: {
    id: number;
    name: string;
    brand?: string;
  } | null;
}

interface ChatMessageProps {
  message: ChatMessageData;
  isOwnMessage: boolean;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({
  message,
  isOwnMessage,
}) => {
  const intl = useIntl();

  const senderFarmName =
    message.sender_farm?.brand ||
    message.sender_farm?.name ||
    intl.formatMessage({ id: 'chat.unknown_sender' });
  const timeText = dayjs(message.created_at).format('HH:mm');

  const getSenderLabel = () => {
    if (isOwnMessage) {
      return intl.formatMessage({ id: 'chat.your_message' });
    }
    const senderUserName = message.sender_user_name?.trim();
    const hasFarmName = message.sender_farm?.name || message.sender_farm?.brand;
    if (senderUserName && hasFarmName) {
      return `${senderUserName} (${senderFarmName})`;
    }
    if (senderUserName) {
      return senderUserName;
    }
    return senderFarmName;
  };

  return (
    <div className={`chat-message ${isOwnMessage ? 'right' : 'left'}`}>
      <div className="chat-message-bubble">
        <span className="chat-message-sender-name">{getSenderLabel()}</span>
        {message.body && (
          <div className="chat-message-content">{message.body}</div>
        )}
        <div className="chat-message-footer">
          {isOwnMessage && (
            <span className="chat-message-status">
              {message.is_read ? (
                <ChatMessageReadIcon size={12} />
              ) : (
                <CheckOutlined style={{ fontSize: 12 }} />
              )}
            </span>
          )}
          <span className="chat-message-time">{timeText}</span>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
